// extracted by mini-css-extract-plugin
export default {"dialogHeight":"540px","dialogHeader":"DialogHeader__dialogHeader___5ck1I","closeDialog":"DialogHeader__closeDialog___1z0e-","dragHandle":"DialogHeader__dragHandle___2D_sy"};